import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { recordStatisticsEvent } from '../../../../services/statistics-service';

const Anchor = styled.a`
  display: block;
  font-weight: ${props => props.theme.fontWeightHeavy};
  font-size: 19px;
  letter-spacing: -0.01em;
  margin-bottom: 4px;
`;

export default function MoreInfo({ fund }) {
  const { id, pdsFileUrl, tmdFileUrl } = fund;

  const handleClick = (eventType, url) => {
    recordStatisticsEvent({
      event: eventType,
      statisticable: 'fund',
      id,
      clicked_url: url,
      page: `${window.location.pathname}#fund-info`,
    });

    return false;
  };

  return (
    <>
      {pdsFileUrl && (
        <Anchor href={pdsFileUrl} target="_blank" rel="noopener noreferrer" onClick={() => handleClick('fund_profile_pds_clicked', pdsFileUrl)}>
          Product Disclosure Statement
        </Anchor>
      )}
      {tmdFileUrl && (
        <Anchor href={tmdFileUrl} target="_blank" rel="noopener noreferrer" onClick={() => handleClick('fund_profile_tmd_clicked', tmdFileUrl)}>
          Target Market Determination
        </Anchor>
      )}
    </>
  );
}

MoreInfo.propTypes = {
  fund: PropTypes.shape({
    id: PropTypes.number,
    pdsFileUrl: PropTypes.string,
    tmdFileUrl: PropTypes.string,
  }).isRequired,
};
